import { Observable } from 'rxjs';
import { UserModel } from '../models/user.model';
import { AdvancesAvailableModel } from '../models/advance-available.model';
import { PaginatedData } from '@base/wrappers/paginated-data';
import { CatalogModel } from '@domain/models/catalog.model';

export abstract class CatalogRepository {
  abstract getCatalogDocumentTypes(
    pageNumber: number,
    pageSize: number
  ): Observable<PaginatedData<CatalogModel>>;

  abstract getCataloAdvancesAvailable(
    pageNumber: number,
    pageSize: number,
    savingsPlanId :string,
  ): Observable<PaginatedData<AdvancesAvailableModel>>;
  abstract getCatalogContributionPrices(): Observable<PaginatedData<number>>;
}
